/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.5 11.134a1 1 0 010 1.732l-15 8.66A1 1 0 016 20.66V3.34a1 1 0 011.5-.866l15 8.66z" _fill="#000"/>'
  }
})
